import React, { useState } from 'react';
import Card, { CardRow } from 'components/styleguide/card/Card';
import Sheet from 'components/styleguide/sheet_modal/Sheet';
import SearchInput, { Item } from 'components/styleguide/search_input/SearchInput';
import { useEditableSheet } from 'components/styleguide/sheet_modal/useEditableSheet';
const styles = require('../onboarding-cards.module.scss');

interface LanguagesCardProps {
  languages: Item[];
  languagesList: Item[];
  url: string;
  required?: boolean;
}

const LanguagesCard: React.FC<LanguagesCardProps> = ({ languages: initialLanguages, languagesList, url, required = false }) => {
  const [languages, setLanguages] = useState<Item[]>(initialLanguages || []);
  const [pendingLanguages, setPendingLanguages] = useState<Item[]>([]);

  const sheet = useEditableSheet({
    url: url,
    payloadKey: 'talent',
    onSuccess: () => {
      setLanguages(pendingLanguages);
    },
  });

  const hasAny = languages.length > 0;
  const tag = hasAny
    ? undefined
    : required
      ? { variant: 'error' as const, icon: 'circleAlert' as const, children: 'Mandatory' }
      : { variant: 'warning' as const, icon: 'circleAlert' as const, children: 'Missing' };

  const handleAddClick = () => {
    sheet.open('Add languages', {});
  };

  const handleEditClick = () => {
    setPendingLanguages(languages);
    sheet.open('Edit languages', {
      language_proficiency_ids: languages.map(l => l.value),
    });
  };

  const handleLanguagesChange = (updated: Item[]) => {
    setPendingLanguages(updated);
    sheet.handleFormChange('language_proficiency_ids', updated.map(l => l.value));
  };

  return (
    <>
      <Card
        title="Languages"
        iconName="globe"
        context="talent"
        tag={tag}
        onEdit={handleEditClick}
        onAdd={hasAny ? undefined : handleAddClick}
      >
        {hasAny && (
          <CardRow context="talent">
            <p className={styles.value}>
              {languages.map(l => l.label).join(', ')}
            </p>
          </CardRow>
        )}
      </Card>

      {sheet.isOpen && (
        <Sheet
          title={sheet.sheetTitle}
          onClose={sheet.close}
          context="talent"
          showCancelButton={false}
          continueButtonText="Save"
          onContinue={sheet.handleSave}
        >
          <SearchInput
            initialItems={languages}
            options={languagesList}
            label="Languages"
            placeholder="e.g. English"
            required={true}
            error={sheet.getError('language_proficiency_ids')}
            onChange={handleLanguagesChange}
          />
        </Sheet>
      )}
    </>
  );
};

export default LanguagesCard;
